// @flow
import _ from 'lodash';

import { getJSON } from 'redux-api-middleware';
import { I18n } from '@shopify/react-i18n';
import { showSABToast } from 'src/integrations/shopify-app-bridge/toast';
import { store } from 'src/stores/store';
import * as oauthAction from 'actions/oauth-actions';
import { BACKEND_MESSAGES } from 'src/constants/message';

const backEndErrorCodes = Object.keys(BACKEND_MESSAGES);

/**
 * Process the respond data
 *
 * @param  {any}   res respond data
 * @param  {string}   type type of notification
 * @param  {string}   title notification title
 *
 * @return {any} data format response data
 */
export const processRes = async (res: any, type: string = '', title: string = '', i18n: I18n, silent: boolean = false) => {
  const data = await getJSON(res);
  if (type !== '') {
    let message = _.get(data, 'message', '');

    // If message is returned in response but we want to customize it
    if (message && title && type === 'custom') {
      message = title;
    }

    switch (type) {
      case 'info': {
        // Update message if no message from result
        if (!message) {
          message = title;
        }
        break;
      }
      case 'error': {
        // Update message if no message from result
        if (!message) {
          message = i18n.translate('AdminHTML.Helpers.ActionsHelper.processRes_Error', {
            nt_error_message: title,
            nt_error_code: res.status
          });
        }

        if (parseInt(res.status) === 401) {
          store.dispatch(oauthAction.unauthorizedAccess());
        }
        break;
      }
      case 'custom-with-sync': {
        // Using custom message
        message = title;

        const scheduleSyncAfter = _.get(data, 'scheduleSyncAfter', 0);
        if (scheduleSyncAfter) {
          message += ' ';
          message += i18n.translate('AdminHTML.Helpers.ActionsHelper.processRes_CustomWithSync', {
            nt_duration_in_minute: i18n.translate('AdminHTML.Common.Duration.minute', {
              count: scheduleSyncAfter,
              nt_number: i18n.formatNumber(scheduleSyncAfter)
            })
          });
        }
        break;
      }
      case 'custom': {
        // If message is returned in response but we want to customize it
        if (title) {
          message = title;
        }
        break;
      }

      default: {
        // Update message if no message from result
        if (!message) {
          message = title;
        }
      }
    }
    if (!data) {
      return type === 'error' ? { data, code: res.status } : data;
    }

    // Translate backend error message
    const errorCode = _.get(data, 'errorCode', '');
    if (data && backEndErrorCodes.includes(errorCode)) {
      const errorParams = _.get(data, 'errorParams', '');
      let params = undefined;
      if (!_.isEmpty(errorParams)) {
        const values = Object.values(errorParams);
        params = {
          nt_number: values[0]
        };
      }
      message = i18n.translate(BACKEND_MESSAGES[errorCode], params);
    }

    if (!silent) await showSABToast(message, type === 'error');
  }
  return type === 'error' ? { data, code: res.status } : data;
};
